import { useEffect, useState } from 'react';
import { useMapInstance } from 'shared/map-exports';

const roundToDecimalPlaces = (value: number, decimalPlaces: number): number => {
  return Number(value.toFixed(decimalPlaces));
};

export const useMapZoomLevel = (): number | undefined => {
  const map = useMapInstance();
  const [zoom, setZoom] = useState<number | undefined>(() =>
    map?.getZoom() ? roundToDecimalPlaces(map.getZoom(), 2) : undefined,
  );

  useEffect(() => {
    if (!map) {
      return () => {};
    }

    const handleZoomEnd = (): void => {
      setZoom(roundToDecimalPlaces(map.getZoom(), 2));
    };

    map.on('zoomend', handleZoomEnd);

    return () => {
      map.off('zoomend', handleZoomEnd);
    };
  }, [map]);

  return zoom;
};
